export default __webpack_public_path__ + "static/testimonials-5adfaa10bd050c9896cb7ade0a9d2371.jpg";